module.exports = __webpack_public_path__ + "static/skyway-feed-a6d00308db96235ea97377e1f30ae17f.mp4";